import React, { useState } from 'react';
import { Boxed } from '../../../components/Boxed.components';
import { Input } from '../../../components/Input.components';
import { Button } from '../../../components/Button.components';
import { Theme } from '../../../utils/theme';
import { Grid } from '../../../components/Grid.components';
import { Avatar } from '../../../components/Avatar.components';
import { Text } from '../../../components/Text.components';
import { formatDateTime } from '../../../utils/utils';
import moment from 'moment';

export const Comment = (props) => {
  // state props
  const { applicationData, profile, isLoading } = props;

  // dispatch props
  const { createComment } = props;

  const [text, setText] = useState('');

  const onSubmit = () => {
    if (text && text?.trim()) {
      let payload = { comment: text, _id: applicationData?._id, callback: reset }
      console.log({ payload });
      createComment(payload);
    }
  };

  const [commentList, setCommentList] = useState(applicationData?.comments ?? []);

  const reset = () => {
    const newComment = { 
      value: text,
      createdAt: moment().utc().format('YYYY-MM-DDTHH:mm:ss'),
      _id: moment().utc().format('YYYY-MM-DDTHH:mm:ss'),
      owner: profile,
    }
    setCommentList(prev => [...prev, newComment])
    setText('')
  };

  const CommentCard = ({ item }) => {
    const { value, createdAt, owner } = item;
    return (
      <Boxed pad="10px" background={Theme.TertiaryDark} borderRadius={Theme.PrimaryRadius}>
        <Grid desktop="40px auto" tablet="40px auto" mobile="40px auto">
          <Boxed>
            <Avatar src={owner?.profilePictureUrl} />
          </Boxed>
          <Boxed pad="5px 0">
            <Text color={Theme.SecondaryTextColor} fontSize={Theme.SecondaryFontSize}>
              <span color={Theme.PrimaryColor}>{owner?.lastName} {owner?.firstName}</span> -{' '}
              {createdAt && formatDateTime(createdAt)}
            </Text>
            <Text fontSize={Theme.SecondaryFontSize}>{value}</Text>
          </Boxed>
        </Grid>
      </Boxed>
    );
  };

  return (
    <Boxed pad="20px 0">
      <Boxed pad="0 0 15px 0">
        {commentList?.map((item) => {
          if (item?.value) {
            return (
              <Boxed pad="5px 0">
                <CommentCard item={item} />
              </Boxed>
            );
          } else {
            return null;
          }
        })}
      </Boxed>

      <Grid desktop="40px auto" tablet="40px auto" mobile="40px auto">
        <Boxed>
          <Avatar src={profile?.profilePictureUrl} />
        </Boxed>
        <Input
          type="text"
          placeholder="Add comment..."
          value={text}
          onChange={(e) => setText(e?.target?.value)}
        />
      </Grid>

      <Boxed pad="10px 0" align="right">
        <Button progress={isLoading} disabled={isLoading} onClick={() => onSubmit()}>
          Save
        </Button>
      </Boxed>
    </Boxed>
  );
};
